//调用入口
export default {


	initSystemData(context, obj) {
		context.commit('initSystemData', obj)
	},
	Login(context, obj) {
		context.commit('Login', obj)
	},
	LogOut(context) {
		context.commit('LogOut')
	},
	SetQuery(context, obj) {
		context.commit('SetQuery', obj)
	},
	SetSearch(context, obj) {
		context.commit('SetSearch', obj)
	},
	PushRouter(context, obj) {
		context.commit('PushRouter', obj)
	},
	BackRouter(context, obj) {
		context.commit('BackRouter', obj)
	},
	SetLoanInfos(context, obj) {
		context.commit('SetLoanInfos', obj)
	},
	SetShowLoanInfo(context, obj) {
		context.commit('SetShowLoanInfo', obj)
	},
	SetCompanyName(context, obj) {
		context.commit('SetCompanyName', obj)
	},


}


// WEBPACK FOOTER //
// ./src/store/actions.js